import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Popper from '@material-ui/core/Popper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

import Caret from '../../../../assets/images/icons/caret.svg';

import * as styles from './styles/styles.module.scss';

// todo: Its unfortunate to have this very important style definition here in js. figure out a way to move this into css module
const paperBoxShadow = '0 16px 32px 0 rgba(0, 0, 0, 0.16), 0 0 4px 0 rgba(0, 0, 0, 0.08)';

const useStyles = makeStyles(() => ({
  paper: {
    top: '37px !important',
    borderRadius: '8px',
    zIndex: 9,
    padding: '24px',
    minWidth: '240px',
    background: 'white',
    boxShadow: paperBoxShadow,
    maxHeight: '70vh',
    overflowY: 'auto'
  }
}));

const seoStyles = makeStyles(() => ({
  paper: {
    top: '47px !important',
    borderRadius: '8px',
    zIndex: 9,
    padding: '24px',
    minWidth: '240px',
    background: 'white',
    boxShadow: paperBoxShadow,
    maxHeight: '70vh',
    overflowY: 'auto'
  }
}));

export default function FilterButton({ filterKey, title, content, active, variant, handleClick }) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);
  const id = open ? 'spring-popper' : undefined;

  const configs = {
    default: {
      classes: useStyles(),
      modifiers: {
        flip: {
          enabled: true
        },
        preventOverflow: {
          enabled: true,
          boundariesElement: 'scrollParent',
          padding: 0
        }
      }
    },
    seoPage: {
      classes: seoStyles(),
      modifiers: {
        flip: {
          enabled: true
        },
        preventOverflow: {
          enabled: true,
          boundariesElement: 'scrollParent',
          padding: 0
        },
        placements: ['bottom-start', 'bottom-end']
      }
    }
  };

  const config = configs[variant] ?? configs.default;

  const handlePopperClick = event => {
    // eslint-disable-next-line no-unused-expressions
    handleClick?.(filterKey, !open);
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleClickAway = () => {
    setAnchorEl(null);
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div>
        <button
          aria-describedby={id}
          className={`${styles.container} ${styles[variant]} ${open || active ? styles.open : ''}`}
          onClick={handlePopperClick}
        >
          <div>
            {title} {active ? `(${active})` : ''}
          </div>
          <div className={`${styles.indicator} ${open ? styles.invert : ''}`}>
            <img alt={StringConstantsMixin.strings.ALT_TEXT.CARET} src={Caret} />
          </div>
        </button>
        <Popper
          id={id}
          open={open}
          anchorEl={anchorEl}
          disablePortal
          className={config.classes.paper}
          placement="bottom-start"
          modifiers={config.modifiers}
        >
          <div>{content}</div>
        </Popper>
      </div>
    </ClickAwayListener>
  );
}

FilterButton.defaultProps = {
  filterKey: '',
  content: React.Fragment,
  active: '',
  variant: '',
  handleClick: () => {}
};

FilterButton.propTypes = {
  filterKey: PropTypes.string,
  title: PropTypes.string.isRequired,
  content: PropTypes.element,
  active: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  variant: PropTypes.string,
  handleClick: PropTypes.func
};
